<script lang="ts">
    import Vue from "vue";
    import { Component } from 'vue-facing-decorator';
    import { AlternativeEditorAttributeFieldReadModel } from "@Alternatives/Alternatives/Domain/readmodels";
    import { guid } from "@common/Guid";
    import { ValidationError } from "@common/types";

    @Component({
        props: {
            propF: { type: Object, required: true },
            propErrors: { type: Array, required: true },
        },
        watch: {
            values: { handler: 'onValuesChanged', deep: true }
        }
    })
    export default class NumberInputMultiValue extends Vue
    {
        get f(): AlternativeEditorAttributeFieldReadModel { return this.$props.propF as AlternativeEditorAttributeFieldReadModel; }
        get errors(): ValidationError[] { return this.$props.propErrors as ValidationError[]; }  

        get error() { return this.errors?.find(error => error.Context.startsWith(`AlternativeAttribute:${this.f.Id}`))?.Error; }
        
        values: ValueViewModel[] | null = null;

        //@Watch('values', { deep: true })
        onValuesChanged()
        {
            this.updateReadModel();
        }

        updateReadModel()
        {
            this.f.Values = this.values.map(v => v.Value);
        }

        addValue()
        {
            this.values.push(new ValueViewModel(null));
        }

        removeValue(v: ValueViewModel)
        {
            this.values.remove(v);
        }

        mounted()
        {
            this.values = this.f.Values.map(v => new ValueViewModel(v));
        }
    }

    class ValueViewModel
    {
        Id: string = guid();
        Value: number | null = null;
        Error: string | null = null;

        constructor(value: number | null)
        {
            this.Value = value;
        }
    }
</script>

<template>
    <div class="form-group">
        <label>
            <span v-if="f.IsRequired" style="color: red;">*</span> {{f.Name}}
            <span v-if="f.IsReadonly === false">(<a @click="addValue" class="text-primary">add</a>)</span>
        </label>
        <div v-for="v in values" :key="v.Id">
            <div class="input-group">

                <input type="number" class="form-control" placeholder="Number..." title="Please enter number"
                       v-model.number="v.Value"
                       :readonly="f.IsReadonly === true"
                       :min="f.MinValue != null ? f.MinValue : null"
                       :max="f.MaxValue != null ? f.MaxValue : null"
                       step="any" />

                <div class="input-group-append">
                    <button :disabled="f.IsReadonly === true" @click="removeValue(v)" class="btn btn-outline-secondary" type="button">
                        <span class="fa fa-times"></span>
                    </button>
                </div>
            </div>

            <div class="error">{{v.Error}}</div>
        </div>
        <div class="error">{{error}}</div>
        <small class="form-text text-muted" v-if="f.Description">{{f.Description}}</small>
    </div>
</template>